import { SET_SELECTED_INTERACTOR } from "constants/app";

export default (state = null, action) => {
  switch (action.type) {
    case SET_SELECTED_INTERACTOR:
      return action.value;
    default:
      return state;
  }
};
